import React, { useMemo, useRef, useState } from "react";
import "./HomePage.css";

const heroImage = "/gofastigotta_vertical.jpg";
const bgVideo = "/background_video.mp4";

const CF_BASE = "https://d3djb3o6lrhkmi.cloudfront.net";

const TRACKS = [
  { title: "Hero's Comeback - gofastigotta Remix", file: "Hero's Comeback - gofastigotta Remix.mp3" },
  { title: "The Rumbling from Attack on Titan - gofastigotta Remix", file: "The Rumbling from Attack on Titan - gofastigotta Remix.mp3" },
  { title: "I Shit My Pants in the Club ft Reber Kellam", file: "I Shit My Pants in the Club ft Reber Kellam.mp3" },
  { title: "The Saturator ft Reber Kellam", file: "The Saturator ft Reber Kellam.mp3" },
  { title: "il vento doro - gofastigotta Remix", file: "il vento doro - gofastigotta Remix.mp3" },
  { title: "Intrusive", file: "Intrusive.mp3" },
  { title: "Nothing", file: "Nothing.mp3" },
  { title: "Cha-La Head Cha-La - Blue House Remix", file: "Cha-La Head Cha-La - Blue House Remix.mp3" },
  { title: "Sailor Moon - gofastigotta Remix", file: "Sailor Moon - gofastigotta Remix.mp3" },
  { title: "Lost Woods - gofastigotta Remix", file: "Lost Woods - gofastigotta Remix.mp3" },
  { title: "I Really Want to Stay at Your House - gofastigotta Remix", file: "I Really Want to Stay at Your House - gofastigotta Remix.mp3" },
  { title: "This Fire - gofastigotta Remix", file: "This Fire - gofastigotta Remix.mp3" },
  { title: "Where Our Blue Is Blue House Remix - No Vox", file: "Where Our Blue Is Blue House Remix - No Vox.mp3" },
];

export default function HomePage() {
  const audioRef = useRef(null);

  const [currentIndex, setCurrentIndex] = useState(null);

  const currentTrack = useMemo(() => currentIndex !== null ? TRACKS[currentIndex] : null, [currentIndex]);

  const selectTrack = (i) => {
    setCurrentIndex(i);
    const el = audioRef.current;
    if (!el) return;
    el.src = encodeURI(`${CF_BASE}/${TRACKS[i].file}`);
    el.load();
    el.play().catch(() => {});
  };

  const playNext = () => selectTrack(currentIndex !== null ? (currentIndex + 1) % TRACKS.length : 0);
  const playPrev = () => selectTrack(currentIndex !== null ? (currentIndex - 1 + TRACKS.length) % TRACKS.length : 0);

  return (
    <main className="home">
      <section className="hero" aria-label="gofastigotta hero">
        <video className="heroVideo" autoPlay muted loop playsInline>
          <source src={bgVideo} type="video/mp4" />
        </video>

        <div className="heroOverlay" />

        <div className="heroContent">
          <img className="brandImage" src={heroImage} alt="gofastigotta" />

          <p className="tagline">
            Producer • Guitar • Vocals • Remixes • Originals
          </p>

          <div className="playerCard">
            <div className="nowPlaying">
              <span className="nowLabel">Now playing</span>
              <span className="nowTitle">
                {currentTrack ? currentTrack.title : "Select a song to listen"}
              </span>
            </div>

            <audio
              ref={audioRef}
              className="audio"
              controls
              preload="metadata"
              onEnded={playNext}
            />

            <div className="playerControls">
              <button className="btn" onClick={playPrev} type="button">
                Prev
              </button>
              <button className="btn" onClick={playNext} type="button">
                Next
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="tracklist" aria-label="Track list">
        <h2 className="sectionTitle">Tracks</h2>

        <div className="tracks">
          {TRACKS.map((t, i) => {
            const isActive = i === currentIndex;
            return (
              <button
                key={`${t.file}-${i}`}
                className={`trackRow ${isActive ? "isActive" : ""}`}
                onClick={() => selectTrack(i)}
                type="button"
              >
                <span className="trackIndex">{String(i + 1).padStart(2, "0")}</span>
                <span className="trackName">{t.title}</span>
              </button>
            );
          })}
        </div>
      </section>
    </main>
  );
}
